/* eslint-disable max-lines */
import React, { Component, Fragment, lazy } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Typography } from '@material-ui/core';
import { isMobileOnly, isTablet, isMobile } from 'react-device-detect';
import classnames from 'classnames';
import { StatusCodes } from 'http-status-codes';

import ThemeService from 'themes/ThemeService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import EpayService from 'services/EpayService/EpayService';
import { translate } from 'services/i18nService';
import ModalService from 'services/ModalService';
import trackingService from 'services/UITrackingService';
import UserStore from 'stores/UserStore';
import IssuersPage from 'pages/IssuersPage/IssuersPage';
import ForumPayConfirmModal from 'pages/ForumPayConfirmModal/ForumPayConfirmModal';
import LoadingButton from 'components/LoadingButton/LoadingButton';
import LoadingLogo from 'components/LoadingLogo/LoadingLogo';
import Modal from 'components/Modal/Modal';
import ReactSelect from 'components/ReactSelect/ReactSelect';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';
import { BONUS_TOKENS } from 'enum/campaigns';
import DEFAULT_PROCESSORS_BY_COUNTRY from 'enum/defaultProcessorsByCountry';
import { EPAY_PRODUCT_TYPES } from 'enum/payments';
import routeDefinitions from 'enum/routeDefinitions';
import allUserGroups from 'enum/userGroups';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import parseCatch from 'utils/parseCatch';
import {
  getFormattedAmount,
  generateID,
  formatSEKValue,
  hasIssuers,
} from 'utils/helpers';
import {
  actionCreators as paymentActions,
  selector as paymentSelector,
} from 'features/Payment/State';
import {
  actionCreators as appActions,
  selector as appSelector,
} from 'app/AppState';
import {
  actionCreators as userListActions,
  selector as userSelector,
} from 'pages/User/State';
import {
  actionCreators as directoryListActions,
  selector as directorySelector,
} from 'pages/Directory/State';
import { RegistrationModalCaller } from 'pages/RegistrationModal/utils';

import { initFirebase, FirebaseMain } from '../../firebase/firebase';
import ForumPayLogo from '../../../images/payment/ForumPayLogo.png';

import Option from './Option';
import PaymentMethods from './PaymentMethods';
import PaymentPackages from './PaymentPackages';
import Value from './Value';
import TokenBannerPorndoe from './TokenBannerPorndoe';
import { getPorndoeBrandType } from './TokenBannerPorndoe/helpers';
import styles from './BuyTokensModal.css';


const CRYPTO_PAYMENT_CHECK_DELAY = 5 * SECOND_AS_MILLISECONDS;

const SFWAgeVerificationTemplate = lazy(() =>
  import('components/SFWAgeVerificationTemplate/SFWAgeVerificationTemplate')
);

const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

@connect(appSelector, (dispatch) => {
  return { appActions: bindActionCreators(appActions, dispatch) };
})
@connect(userSelector, (dispatch) => {
  return { userActions: bindActionCreators(userListActions, dispatch) };
})
@connect(paymentSelector, (dispatch) => {
  return { paymentActions: bindActionCreators(paymentActions, dispatch) };
})
@connect(directorySelector, (dispatch) => {
  return { directoryActions: bindActionCreators(directoryListActions, dispatch) };
})
class BuyTokensModal extends Component {
  static propTypes = {
    appActions: PropTypes.object.isRequired,
    directoryActions: PropTypes.object.isRequired,
    isBuyTokensModalVisible: PropTypes.bool.isRequired,
    paymentActions: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
  };

  constructor(...args) {
    super(...args);

    // temp
    this.auth = true;

    this.IDs = {
      prefix: '9hzd0RHZ',
      element: 'buyTokensModal',
      continueButton: 'continueButton',
      upgradeToGoldButton: 'upgradeToGoldButton',
      title: 'title',
      subtitle: 'subtitle',
      transactionFee: 'transactionFee',
      completePurchase: 'completePurchase',
      cryptoCurrencies: 'cryptoCurrencies',
      learnAboutTokens: 'learnAboutTokens',
    };
    this.makeId = generateID(this.IDs.prefix, this.IDs.element);

    this.cryptoPaymentCheckInterval = null;
  }

  state = {
    allowToCloseModal: true,
    cryptoCurrencies: null,
    cryptoCheckoutData: null,
    cryptoPurchaseStatus: null,
    dialXsUrl: 'http://www.dialxs.nl/contact/contact-us/',
    loading: false,
    loadingButton: false,
    loadingIssuersButton: false,
    openAfterLogin: false,
    products: {},
    selectedOption: {},
    selectedPackage: {},
    selectedCryptoCurrency: null,
    showCryptoCurrencies: false,
    showForumPayConfirm: false,
    showIssuers: false,
  };

  componentDidUpdate(prevProps) {
    const { showSFWAgeVerificationModal } = UserStore;
    const {
      isBuyTokensModalVisible,
      user,
      user: { username },
      paymentActions: { showBuyTokensModal, toggleUpsellModal },
    } = this.props;
    // update after you create static part
    const { openAfterLogin } = this.state;
    const shouldFetch = prevProps.isBuyTokensModalVisible !== isBuyTokensModalVisible && isBuyTokensModalVisible;
    if (shouldFetch) {
      const exadsSuccessScript = document.body.querySelector('[data-goal=ea10ca9d671e112c6777a213168403c6]');
      const exadsErrorScript = document.body.querySelector('[data-goal=e12d739fa72c8a47a685822b8802622b4]');

      if (exadsSuccessScript) {
        document.body.removeChild(exadsSuccessScript);
      }

      if (exadsErrorScript) {
        document.body.removeChild(exadsErrorScript);
      }

      if (!showSFWAgeVerificationModal) {
        window.dataLayer.push({
          event: 'BuyTokensOverlay',
          eventCategory: 'tipping',
          eventLabel: 'NA',
        });
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(
        {
          loading: true,
          showForumPayConfirm: false,
        },
        () => {
          const hasMembershipBonus = user.user.getIn(['user', 'paymentInfo', 'hasMembershipBonus']);
          const isBasicUser = user.accessLevel === ACCESS_LEVEL_NUM.BASIC;
          let type = undefined;
          if (showSFWAgeVerificationModal) {
            type = EPAY_PRODUCT_TYPES.AUTH;
          } else if (isBasicUser && !hasMembershipBonus) {
            type = EPAY_PRODUCT_TYPES.TOKENSMEMBERSHIP;
          } else {
            type = EPAY_PRODUCT_TYPES.TOKENS;
          }

          EpayService.getProducts(user.username, user.accessHash, type)
            .then((res) => {
              if (res.status === StatusCodes.OK) {
                trackingService.emit('openBuyTokenOverlay');

                if (res.data.status === 'ERROR' && res.data.reason === 'UPSELL_REQUIRED') {
                  toggleUpsellModal(true);
                  this.hideModal();

                  trackingService.emit('errorBuyTokenOverlay', { reason: res.data.reason });
                  this.addErrorExoclickTag();
                } else {
                  EpayService.setProducts(res.data.products);
                }
              }
              this.setState(
                {
                  loading: false,
                  products: EpayService.products,
                },
                () => this.setSelectedOption()
              );
            })
            .catch((err) => {
              parseCatch(err);
              this.setState({ loading: false });

              trackingService.emit('errorBuyTokenOverlay', { error: err });
              this.addErrorExoclickTag();
            });
        }
      );
    }

    if (prevProps.isBuyTokensModalVisible !== isBuyTokensModalVisible) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ showIssuers: false });
    }

    if (user !== prevProps.user && username && openAfterLogin) {
      showBuyTokensModal();
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ openAfterLogin: false });
    }

    if (!user.username && openAfterLogin) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ openAfterLogin: false });
    }
  }

  componentWillUnmount() {
    clearInterval(this.cryptoPaymentCheckInterval);
  }


  addErrorExoclickTag() {
    const exadsErrorScript = document.body.querySelector('[data-goal=12d739fa72c8a47a685822b8802622b4]');
    if (exadsErrorScript) {
      return;
    }

    const exadsSuccessScript = document.body.querySelector('[data-goal=ea10ca9d671e112c6777a213168403c6]');
    if (exadsSuccessScript) {
      document.body.removeChild(exadsSuccessScript);
    }

    const script = document.createElement('script');
    script.type = 'application/javascript';
    script.src = 'https://a.exoclick.com/tag_gen.js';
    script.setAttribute('data-goal', '12d739fa72c8a47a685822b8802622b4');
    document.body.append(script);
  }

  setSelectedOption = (selectedOption = {}) => {
    const { products } = this.state;
    const { user } = this.props;
    const values = Object.keys(products);
    const device = isMobile ? 'mobile' : 'desktop';
    let defaultProcessor = values[0];
    const localProcessor = DEFAULT_PROCESSORS_BY_COUNTRY[user?.realCountry];
    if (localProcessor && values.includes(localProcessor[device])) {
      defaultProcessor = localProcessor[device];
    }

    const selValue = selectedOption.value || defaultProcessor;

    if (selValue === 'CR') {
      EpayService.getCryptoCurrencies(selectedOption, user)
        .then((res) => {
          if (res.data && res.data.CR) {
            EpayService.setCryptoCurrencies(res.data.CR);

            this.setState(
              {
                cryptoCurrencies: EpayService.availableCryptoCurrencies,
                showCryptoCurrencies: true,
              },
              () => {
                this.finalizeOptionSelecting(values, products, selValue);
                this.onChangeCryptoCurrency();
              }
            );
          }
        })
        .catch((err) => {
          parseCatch(err);
        });
    } else {
      this.setState(
        {
          showCryptoCurrencies: false,
          cryptoCurrencies: null,
          selectedCryptoCurrency: null,
        },
        () => this.finalizeOptionSelecting(values, products, selValue)
      );
    }
  };

  finalizeOptionSelecting = (values, products, selValue) => {
    if (values.length) {
      const { selectedOption } = this.state;

      const selectedValueLabel = translate(
        `payment.processor.${products[selValue].processorId}_${selValue}.displayName`
      );
      const { processorId, hasOneClick, products: selectedValueProducts } = products[selValue];
      const defaultProductForSelectedMethod = (
        selectedValueProducts.find((prod) => prod.details && prod.details.default) ||
        selectedValueProducts[0]
      );

      this.setState({
        selectedOption: {
          value: selValue,
          label: selectedValueLabel,
          hasOneClick,
          processorId,
        },
        selectedPackage: defaultProductForSelectedMethod,
      });

      trackingService.emit('selectPaymentMethodOnBuyTokenOverlay', {
        selectedValue: selValue,
        selectedLabel: selectedValueLabel,
        isCrypto: (selectedOption.value && selectedOption.value === 'CR'),
        processorId,
      });
      trackingService.emit('selectPackageOnBuyTokenOverlay', {
        selectedPackage: defaultProductForSelectedMethod,
        default: true,
      });
    }
  };

  processCryptoPayment = () => {
    const { details: { hash, processorId, purchaseId } } = this.state.cryptoCheckoutData;

    this.cryptoPaymentCheckInterval = setInterval(
      () =>
        EpayService.getCryptoCurrencyPaymentConfirmation(processorId, purchaseId, hash)
          .then((res) => {
            // other statuses can either be PAID or FAILED
            if (res.data && res.data.status && res.data.status.toUpperCase() !== 'PENDING') {
              clearInterval(this.cryptoPaymentCheckInterval);
              this.setState({ cryptoPurchaseStatus: res.data.status.toUpperCase() });
            }
          })
          .catch((err) => {
            this.setState({ cryptoPurchaseStatus: 'FAILED' });
            clearInterval(this.cryptoPaymentCheckInterval);
            parseCatch(err);
          }),
      CRYPTO_PAYMENT_CHECK_DELAY
    );
  };

  proceedPurchaseRequest = (selectedIssuerMethod) => {
    const { user: { username, accessHash, email, user } } = this.props;
    const {
      selectedPackage,
      selectedOption,
      selectedOption: { value },
      selectedPackage: { id },
      selectedCryptoCurrency,
    } = this.state;
    const cryptoCurrencyValue = selectedCryptoCurrency && selectedCryptoCurrency.value;
    const activeCampaign = this.getPrimaryCampaign(user.get('user').get('activeCampaigns'));

    const cryptoCurrencyCurrencyForConversion =
      selectedCryptoCurrency && selectedCryptoCurrency.cryptoData && selectedCryptoCurrency.cryptoData.currency_fiat;
    const campaignDetails = activeCampaign && activeCampaign.get('campaignDetails');
    const showXSell = campaignDetails && campaignDetails.get('showXSell');
    const offerUid =
      activeCampaign && activeCampaign.get('passThrough') && activeCampaign.get('passThrough').get('offerUid');

    let device = 'desktop';
    if (isMobileOnly) {
      device = 'mobile';
    } else if (isTablet) {
      device = 'tablet';
    }

    const options = {
      originalDomain: BASE_URL || location.origin,
      siteSubcat: 'cam4.com',
      returnPath: routeDefinitions.checkout,
      accessHash,
      device,
      email,
      paymentType: value,
      issuer: selectedIssuerMethod && selectedIssuerMethod.value,
    };

    if (showXSell) {
      options.showXSell = showXSell;
    }

    if (cryptoCurrencyValue) {
      options.currency = cryptoCurrencyCurrencyForConversion && cryptoCurrencyCurrencyForConversion.toLowerCase();
      options.paymentCurrency = cryptoCurrencyValue;
    }

    if (offerUid) {
      if (typeof options.passThrough === 'object') {
        options.passThrough.offerUid = offerUid;
      } else {
        const passThrough = { offerUid };
        options.passThrough = passThrough;
      }
    }

    if (hasIssuers(value)) {
      this.setState({ loadingIssuersButton: true });
    }

    const processorId = selectedPackage?.categories?.reduce((procId, category) => {
      const foundProcessorId = category.methods.find((method) => method.type === value)?.processorId;

      return foundProcessorId || procId;
    }, selectedOption.processorId);

    if (!cryptoCurrencyValue) {
      EpayService.openPaymentProcessorWindow(processorId);
    }

    trackingService.emit('clickContinueOnBuyTokenOverlay', {
      processorId,
      options,
      id,
      username,
    });

    this.getPaymentData(processorId, id, username, options)
      .then((res) => {
        if (cryptoCurrencyValue) {
          if (res.status === StatusCodes.OK && res.data?.nextStage) {
            this.setState(
              {
                cryptoCheckoutData: res.data,
                showForumPayConfirm: true,
                allowToCloseModal: false,
              },
              this.processCryptoPayment
            );
          }
        } else {
          this.setState({
            loadingButton: false,
            loadingIssuersButton: false,
          });
          if (res.status === StatusCodes.OK && res.data?.nextStage) {
            EpayService.prepareForm(res.data.nextStage);
            this.hideModal();
            try {
              EpayService.submitForm();
            } catch (error) {
              parseCatch(error);
              EpayService.submitForm();
            }
          }
        }
      })
      .catch((err) => {
        this.setState(
          {
            loadingButton: false,
            loadingIssuersButton: false,
            showCryptoCurrencies: false,
            cryptoCurrencies: null,
            selectedCryptoCurrency: null,
            cryptoCheckoutData: null,
            allowToCloseModal: true,
          },
          () => {
            this.hideModal();
            EpayService.closePaymentProcessorWindow();
            parseCatch(err, true, true);
          }
        );
      });
  };

  getPaymentData = (processorId, packageId, username, options) => {
    if (username) {
      return EpayService.getPaymentProcessorData(processorId, packageId, username, options);
    }

    return EpayService.createGuestAccount().then((res) => {
      if (!res.data) {
        return undefined;
      }

      const { token, userName, firebaseShard, webFirebaseToken } = res.data;
      initFirebase(firebaseShard);

      if (FirebaseMain) {
        FirebaseMain.authWithCustomToken(webFirebaseToken, (err) => {
          if (!err) {
            const { appActions: { watchUserNotificationsUpdate } } = this.props;
            watchUserNotificationsUpdate({ username: userName, accessHash: token }, { guestUser: true });
          }
        });
      }

      if (token && userName) {
        return EpayService.getPaymentProcessorData(processorId, packageId, userName, {
          ...options,
          accessHash: token,
        });
      }

      return undefined;
    });
  };

  changeActivePackage = (selectedPackage) => {
    this.setState({ selectedPackage });

    trackingService.emit('selectPackageOnBuyTokenOverlay', { selectedPackage });
  };

  handleUpgradeToGold = () => {
    const {
      paymentActions: { showUpgradeToGoldModal, toggleRegisterGoldOverlay },
      user: { accessLevel },
    } = this.props;
    this.hideModal();
    if (accessLevel < ACCESS_LEVEL_NUM.BASIC) {
      toggleRegisterGoldOverlay(true);
    } else {
      showUpgradeToGoldModal();
    }
  };

  openRegModal = () => {
    const { appActions: { setShowRegistrationModal } } = this.props;
    setShowRegistrationModal(true, RegistrationModalCaller.BUY_TOKENS_MODAL);
  };

  handleLogin = (e) => {
    const { paymentActions: { hideBuyTokensModal } } = this.props;

    e?.preventDefault?.();

    hideBuyTokensModal();
    ModalService.showModal(
      ModalService.MODAL_KEYS.LOGIN_MODAL_V2,
      { handleOpenRegistrationModal: this.openRegModal }
    );
  };

  hideModal = () => {
    if (!this.state.allowToCloseModal) {
      return;
    }
    const { hideBuyTokensModal } = this.props.paymentActions;
    const { directoryActions } = this.props;
    UserStore.showSFWAgeVerificationModal = false;
    hideBuyTokensModal();
    if (!ModalService?.activeModal?.modalKey === 'MY_SHOP_VIDEO_MODAL') {
      directoryActions.setIsAnyModalShown(false);
    }
    trackingService.emit('closeBuyTokenOverlay');
  };

  resetCryptoPaymentFlow = () => {
    this.setState(
      {
        allowToCloseModal: true,
        showForumPayConfirm: false,
      },
      () => {
        clearInterval(this.cryptoPaymentCheckInterval);
        this.hideModal();
        this.setState({
          showCryptoCurrencies: false,
          cryptoCurrencies: null,
          selectedCryptoCurrency: null,
          cryptoCheckoutData: null,
          cryptoPurchaseStatus: null,
        });
      }
    );
  };

  getPrimaryCampaign(activeCampaigns) {
    const activeCampaign = activeCampaigns && activeCampaigns.size ? activeCampaigns.get(0) : null;

    return activeCampaign;
  }

  onClickPurchaseButton = () => {
    const { selectedOption } = this.state;
    const selectedCryptoAsMethod = selectedOption.value && selectedOption.value === 'CR';
    const selectedIdeal = selectedOption.label && selectedOption.label.toLowerCase() === 'ideal';
    if (!selectedCryptoAsMethod && !selectedIdeal) {
      this.hideModal();
    }
    if (!UserStore.showSFWAgeVerificationModal) {
      window.dataLayer.push({ event: 'epayTransactionSubmit' });
    }

    if (hasIssuers(selectedOption.value) && !selectedOption.hasOneClick) {
      this.setState({ showIssuers: true });
    } else if (selectedCryptoAsMethod) {
      this.proceedPurchaseRequest();
    } else {
      this.setState(
        { loadingButton: true },
        () => this.proceedPurchaseRequest()
      );
    }
  };

  onChangeCryptoCurrency = (selectedCryptoCurrency = {}) => {
    const { cryptoCurrencies } = this.state;
    if (!cryptoCurrencies) {
      return;
    }
    const selectedOption = Object.keys(selectedCryptoCurrency).length ? selectedCryptoCurrency : cryptoCurrencies[0];
    this.setState({ selectedCryptoCurrency: selectedOption });

    trackingService.emit('selectCryptoCurrencyOnBuyTokenOverlay', { selectedOption });
  };

  renderCryptoSelector() {
    const { cryptoCurrencies, selectedCryptoCurrency } = this.state;

    if (cryptoCurrencies) {
      return (
        <div className={styles.cryptoCurrencies}>
          <ReactSelect
            className={styles.selectMenu}
            clearable={false}
            id={this.makeId(this.IDs.cryptoCurrencies)}
            optionComponent={Option}
            options={cryptoCurrencies}
            searchable={false}
            value={selectedCryptoCurrency}
            valueComponent={Value}
            wrapperClass={styles.cryptoSelectWrapper}
            onChange={this.onChangeCryptoCurrency}
          />
          <div className={styles.forumPayWrapper}>
            <span>{translate('payment.powered.by')}</span>
            <img alt="logo" src={ForumPayLogo} />
          </div>
        </div>
      );
    }

    return null;
  }

  renderIssuersPage = () => {
    const { selectedPackage, loadingIssuersButton } = this.state;

    return (
      <IssuersPage
        isLoading={loadingIssuersButton}
        proceedRequest={this.proceedPurchaseRequest}
        selectedPackage={selectedPackage}
      />
    );
  };

  renderForumPayConfirmModal = () => {
    const { cryptoCheckoutData, cryptoPurchaseStatus } = this.state;

    return (
      <ForumPayConfirmModal
        cryptoPurchaseStatus={cryptoPurchaseStatus}
        data={cryptoCheckoutData}
        resetFlow={this.resetCryptoPaymentFlow}
      />
    );
  };

  renderHeader = () => {
    const theme = ThemeService.theme.buyTokensModal;
    const { user } = UserStore;
    const { affiliateCode, paymentInfo } = user;

    if (user.username) {
      const { hasPurchases } = paymentInfo || {};

      if (!hasPurchases && affiliateCode) {
        const porndoeBrand = getPorndoeBrandType(affiliateCode);
        const overrideCampaign = !theme || theme.cookieNamePrefix === BONUS_TOKENS;
        if (porndoeBrand && overrideCampaign) {
          return <TokenBannerPorndoe porndoeBrand={porndoeBrand} />;
        }
      }
    }

    if (theme?.headerClass) {
      const headerClassnames = classnames(styles.campaignHeader, theme.headerClass);

      return (
        <header className={headerClassnames}>
          <div className={styles.tint} />
          <div className={styles.content}>
            <div className={classnames(styles.title, theme.titleClass)} id={this.makeId(this.IDs.title)}>
              {theme.title}
            </div>
            {Boolean(theme.text) && (
              <div className={styles.subtitle} id={this.makeId(this.IDs.subtitle)}>
                {theme.text}
              </div>
            )}
          </div>
        </header>
      );
    }

    return (
      <header className={styles.standardHeader}>
        {translate('epay.epay.modal.select.token.package')}
      </header>
    );
  };

  renderTransactionFee() {
    const { user: { realCountry } } = this.props;
    const { selectedPackage } = this.state;

    const isCountryGermany = realCountry === 'de' || UserStore.hasCF(allUserGroups.USER_COUNTRY_DE);

    const transactionFee = selectedPackage?.details?.tx || 1;

    let transactionFeeAmount = getFormattedAmount(
      transactionFee,
      1,
      selectedPackage.currency.symbol,
      true,
      selectedPackage.currency.symbol === 'kr',
      isCountryGermany
    );
    if (selectedPackage.currency.symbol === 'kr') {
      transactionFeeAmount = `${formatSEKValue(transactionFeeAmount)} kr`;
    }

    return (
      <Typography
        classes={{ body1: styles.transactionFee }}
        id={this.makeId(this.IDs.transactionFee)}
        variant="body1"
      >
        { translate('epay.epay.transaction.fee', {
          0: transactionFeeAmount,
          1: '',
        }) }
      </Typography>
    );
  }

  renderGuestFooter() {
    return (
      <div className={styles.footer}>
        <a
          className={styles.tokensLink}
          href="/token"
          id={this.makeId(this.IDs.learnAboutTokens)}
          target="_blank"
        >
          { translate('payment.learn.about.tokens') }
        </a>
      </div>
    );
  }

  renderPaymentMethods() {
    const { user } = this.props;
    const {
      products,
      selectedOption,
    } = this.state;
    const options = Object.keys(products).map((pt) => {
      return {
        value: pt,
        label: translate(`payment.processor.${products[pt].processorId}_${pt}.displayName`),
        processorId: products[pt].processorId,
        hasOneClick: products[pt].hasOneClick,
      };
    });
    const device = isMobile ? 'mobile' : 'desktop';
    const isCountryInFRITES = ['NL', 'FR', 'IT', 'ES', 'PT'].includes(user.realCountry.toUpperCase());

    const localProcessor = DEFAULT_PROCESSORS_BY_COUNTRY[user?.realCountry];
    const firstProcessor = localProcessor?.[device] || null;

    if (firstProcessor) {
      const processorToMove = options.filter((processor) => processor.value === firstProcessor);
      if (processorToMove.length && JSON.stringify(processorToMove[0]) !== JSON.stringify(options[0])) {
        // re-arrange processors so that the default processor is listed first
        const firstInDropdown = options.splice(options.indexOf(processorToMove[0]), 1)[0];
        options.splice(0, 0, firstInDropdown);
      }
    }

    if (options.length > 1 && isCountryInFRITES) {
      // put PP in second place
      const ppIndex = options.findIndex((option) => option.value === 'PP');
      if (ppIndex > -1 && ppIndex !== 1) {
        const temp = options[1];
        options[1] = options[ppIndex];
        options[ppIndex] = temp;
      }
    }

    if (options.length <= 1) {
      return null;
    }

    return (
      <PaymentMethods
        handleSelection={this.setSelectedOption}
        methods={options}
        selected={selectedOption}
        user={user}
      />
    );
  }

  renderPackagersPage() {
    const {
      user,
      user: { accessLevel },
      user: { username },
    } = this.props;
    const {
      loading,
      products,
      selectedOption,
      selectedPackage,
      loadingButton,
      showCryptoCurrencies,
      selectedCryptoCurrency,
    } = this.state;
    const packages = products[selectedOption.value] ? products[selectedOption.value].products : [];

    const isGoldUser = accessLevel >= ACCESS_LEVEL_NUM.GOLD;
    // several campaigns can be active at the same time
    const allActiveCampaigns = user.user.get('user').get('activeCampaigns');

    const selectedCryptoAsMethod = selectedOption.value && selectedOption.value === 'CR';

    const hasTransactionFee = selectedPackage?.details?.tf;

    if (loading) {
      return <LoadingLogo />;
    }

    return (
      <div className={styles.contentWrapper}>
        { this.renderHeader() }
        <div>
          { this.renderPaymentMethods() }
          { showCryptoCurrencies && this.renderCryptoSelector() }
          <PaymentPackages
            allActiveCampaigns={allActiveCampaigns}
            changeActivePackage={this.changeActivePackage}
            isGoldUser={isGoldUser}
            packages={packages}
            selectedCryptoCurrency={selectedCryptoCurrency}
            selectedMethod={selectedOption}
            selectedPackage={selectedPackage}
            user={user}
          />
          { !selectedCryptoAsMethod && hasTransactionFee && this.renderTransactionFee() }
          <footer className={`${styles.footer} ${styles.footerGold}`}>
            <LoadingButton
              className={styles.continue}
              colorVariant="green"
              customContainerClass={styles.continueContainer}
              id={this.makeId(this.IDs.continueButton)}
              isLoading={loadingButton}
              onClick={this.onClickPurchaseButton}
            >
              { translate('epay.epay.button.continue') }
            </LoadingButton>
          </footer>
          { !username && this.renderGuestFooter() }
        </div>
      </div>
    );
  }

  render() {
    const { isBuyTokensModalVisible } = this.props;
    const {
      loading,
      selectedPackage,
      loadingButton,
      showIssuers,
      showForumPayConfirm,
      allowToCloseModal,
    } = this.state;

    const { showSFWAgeVerificationModal } = UserStore;

    const modalClasses = classnames({
      [styles.loadingLogo]: loading,
      [styles.buyTokens]: !showIssuers && !showSFWAgeVerificationModal,
    });

    const showClose = allowToCloseModal && !loading && !showSFWAgeVerificationModal;
    const scroll = !loading && !showSFWAgeVerificationModal;
    const bg = !loading || showSFWAgeVerificationModal ? 'white' : 'transparent';
    const showPackagesPage = !showIssuers && !showForumPayConfirm;

    return (
      <Modal
        background={bg}
        belongToHeader={true}
        className={modalClasses}
        close={this.hideModal}
        scroll={scroll}
        show={isBuyTokensModalVisible}
        showClose={showClose}
        size="medium"
        type="full"
      >
        <script
          data-goal="2a9107054df6d34d8fcfafa19f74dd9d"
          src="https://a.exoclick.com/tag_gen.js"
          type="application/javascript"
        />
        {showSFWAgeVerificationModal ? (
          <SFWAgeVerificationTemplate
            isLoading={loadingButton}
            notAvailable={!selectedPackage.categories}
            onClick={this.onClickPurchaseButton}
          />
        ) : (
          <Fragment>
            {showPackagesPage && (
              this.renderPackagersPage()
            )}
            {!showPackagesPage && showIssuers && (
              this.renderIssuersPage()
            )}
            {!showPackagesPage && !showIssuers && showForumPayConfirm && (
              this.renderForumPayConfirmModal()
            )}
          </Fragment>
        )}
      </Modal>
    );
  }
}

export default BuyTokensModal;
